import { absolutePath } from "./absolutePath";

export const memberChecklist = {
  show: () => absolutePath("member_checklist"),
  completeItem: () => absolutePath("member_checklist/complete_item"),
  incompleteItem: () => absolutePath("member_checklist/incomplete_item"),
};
